import React, { useState, useEffect, useRef } from "react";
import CourseSearch from "./CourseSearch/CourseSearch";
import "./LandingPage.css";
import LicenseTypes from "./LicenseTypes/LicenseTypes";
import Footer from "../../Components/Footer/Footer";
import SearchTiles from "./SearchTiles/SearchTiles.jsx";
import VehicleType from "./VehicleType/VehicleType";
import useCheckLogin from "../../Helpers/CustomHooks/CheckLogin";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { OpenLoginSignUp } from "../../Actions/ToggleSignupA";
import ForgotPassword from "../../popups/forget-password/ForgotPassword.jsx";
import NewPassword from "../../popups/newPassword/NewPassword.jsx";
import OtpPopup from "../../popups/otpPopup/OtpPopup.jsx";
import { useAuthContext } from "../../context/authContext.js";
import Terms from "../../popups/termsAndConditons/Terms.jsx";
import Courses from "./CourseSearch/Courses.jsx";
import Stars from "../../Components/starsAndReviews/Stars.jsx";
import { useLocationContext } from '../../context/locationContext.js'
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { Button, Box } from "@mui/material";
import HowVLIAddValueBtn from "./HowVLIAddValue/HowVLIAddValue";


const LandingPage = ({ children }) => {
  useCheckLogin(false, []);
  const activeValue = sessionStorage.getItem("searchTiles")
  const [activeSection, setActiveSection] = useState(
    activeValue ? activeValue : null
  );
  const [searchCourse, setSearchCourse] = useState("");

  const { forgotPass, resetPass, terms, otpPopup } = useAuthContext();
  const { UserInfo } = useSelector((Store) => Store.LoginSignupReducer);
  const { location, setLocation } = useLocationContext(); // Use the context
  const [showLocationPrompt, setShowLocationPrompt] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);
  const [requestCount, setRequestCount] = useState(0);
  const locationIntervalRef = useRef(null);

  console.log("searchCourse", searchCourse);

  // Check if location is already set
  const isLocationSet = location?.country || location?.state || location?.city || location?.postalCode;

  //to get user lat and long and to convert them in user current location
  // useEffect(() => {
  //   let locationInterval;

  //   const fetchLocation = async () => {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         async (position) => {
  //           setPermissionDenied(false); // Reset denied state if successful

  //           const { latitude, longitude } = position.coords;
  //           try {
  //             const response = await axios.get(
  //               `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
  //             );
  //             const address = response.data.address || {};
  //             const { country, city, state, postcode } = address;

  //             setLocation({
  //               country: country || "",
  //               state: state || "",
  //               city: city || "",
  //               postalCode: postcode || "",
  //             });

  //             setShowLocationPrompt(false); // Hide prompt if location is set
  //           } catch (error) {
  //             console.error("Error fetching location details:", error);
  //           }
  //         },
  //         (error) => {
  //           console.error("Error getting location:", error);
  //           if (error.code === error.PERMISSION_DENIED) {
  //             setPermissionDenied(true); // Show custom modal if permission is denied
  //             setShowLocationPrompt(true);
  //           }
  //         }
  //       );
  //     } else {
  //       console.error("Geolocation is not supported by this browser.");
  //       setShowLocationPrompt(true);
  //     }
  //   };

  //   if (!isLocationSet) {
  //     fetchLocation();
  //     locationInterval = setInterval(fetchLocation, 10000);
  //   }

  //   return () => clearInterval(locationInterval);
  // }, [isLocationSet]);

  useEffect(() => {
    const fetchLocation = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            setPermissionDenied(false);
            setShowLocationPrompt(false);
            const { latitude, longitude } = position.coords;

            try {
              const response = await axios.get(
                `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
              );
              const address = response.data.address || {};
              setLocation({
                country: address.country || "",
                state: address.state || "",
                city: address.city || "",
                postalCode: address.postcode || "",
              });
            } catch (error) {
              console.error("Error fetching location details:", error);
            }
          },
          (error) => {
            console.error("Error getting location:", error);
            if (error.code === error.PERMISSION_DENIED) {
              setRequestCount((prev) => prev + 1);
            }
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    };

    // Fetch location initially if not already set
    if (!isLocationSet && requestCount <= 3) {
      fetchLocation();
    }

    // If denied 3 times, start showing popup every 10 seconds
    if (requestCount >= 3 && !locationIntervalRef.current && !isLocationSet) {
      locationIntervalRef.current = setInterval(() => {
        setShowLocationPrompt(true);
      }, 10000);
    }

    return () => {
      if (locationIntervalRef.current) {
        clearInterval(locationIntervalRef.current);
        locationIntervalRef.current = null;
      }
    };
  }, [location, requestCount]);

  const handleClosePrompt = () => {
    setShowLocationPrompt(false); // Hide popup temporarily
  };

  // useEffect(() => {
  //   let locationInterval;

  //   if (!isLocationSet) {
  //   const fetchLocation = async () => {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         async (position) => {
  //           const { latitude, longitude } = position.coords;
  //           try {
  //             const response = await axios.get(
  //               `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
  //             );
  //             const address = response.data.address || {}; // Use an empty object as a default
  //             const { country, city, state, postcode } = address;
              
  //             // Log the location details to the console
  //             console.log('Country:', country || 'Country not available');
  //             console.log('State/Region:', state || 'State/Region not available');
  //             console.log('City:', city || 'City not available');
  //             console.log('Postal Code:', postcode || 'Postal code not available');

  //              // Update context with the location details
  //             setLocation({
  //               country: country || '',
  //               state: state || '', // Depending on the response, `state` or `region` might be available
  //               city: city || '',
  //               postalCode: postcode || '', // Use `postcode` for postal code
  //             });
  //           } catch (error) {
  //             console.error('Error fetching location details:', error);
  //           }
  //         },
  //         (error) => {
  //           console.error('Error getting location:', error);
  //         }
  //       );
  //     } else {
  //       console.error('Geolocation is not supported by this browser.');
  //     }
  //   };
  
  //   fetchLocation();
  // }
  // }, []);


  return (
    <>
      {terms ? <Terms /> : null}
      {forgotPass && <ForgotPassword />}
      {otpPopup ? <OtpPopup /> : null}
      {resetPass ? <NewPassword /> : null}
      <div className="">
        <div className="bgGradient absolute -z-10 h-[745px] w-full rounded-b-[300px]"></div>
        <div className="relative mb-40 flex   w-full flex-col items-center md:mb-10 md:block">
          <picture className="-z-10 hidden overflow-hidden md:block">
            <img
              className="LandingContainerLite relative -top-5 -left-28"
              onLoad={() => console.log("load")}
              onError={(e) => console.log("error", e)}
              src={require("./Assets/LiteLandingContainer.svg").default}
              alt=""
            />
          </picture>

          {showLocationPrompt && (
            <div className="overlay z-[99999]"
            style={{
              position: "fixed",
              top: "30%",
              left: "50%",
              transform: "translateX(-50%)",
              background: "white",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
              width: "300px",
              textAlign: "center",
              zIndex: 99999,
            }}>
              <div className="popup">
                <h4>Location Access Denied</h4>
                <p>To improve accuracy, enable location permissions.</p>
                <p>
                  <strong>Go to browser settings → Site Permissions → Enable Location</strong>
                </p>
                <button onClick={handleClosePrompt}>OK, Got it</button>
              </div>
            </div>
          )}

          {permissionDenied && (
            <div style={{
              position: "fixed",
              top: "20%",
              left: "50%",
              transform: "translateX(-50%)",
              background: "white",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
              width: "300px",
              textAlign: "center"
            }}>
              <h4>Location Access Denied</h4>
              <p>To improve accuracy, enable location permissions.</p>
              <p><strong>Go to browser settings → Site Permissions → Enable Location</strong></p>
              <button onClick={() => setPermissionDenied(false)} style={{ marginTop: "10px", padding: "5px 10px", border: "none", background: "#007bff", color: "white", borderRadius: "5px", cursor: "pointer" }}>
                OK, Got it
              </button>
            </div>
          )}

          <div className="h- -top-0 w-full rounded-b-[300px] md:absolute md:h-auto md:min-h-fit md:rounded-[0px] md:bg-[#291c5f00] xl:w-full ">
            {UserInfo?.UserName ? null : <LoginRegister />}
            <picture className=" ">
              <source
                media="(max-width:635px)"
                className=""
                srcSet={require("./Assets/Rectangle.svg").default}
              />

              <source
                media="(min-width:768px)"
                srcSet={require("./Assets/LandingContainer.svg").default}
              />
              <img
                className="hidden w-full md:inline-block"
                loading="lazy"
                src={require("./Assets/LandingContainer.svg").default}
                alt=""
              />
            </picture>
          </div>
          
          <div className="top-32  left-0 mt-[150px] flex w-full flex-col items-center justify-around md:absolute md:top-[3rem] md:mt-0 md:flex-row">
            <div className=" mx-1 flex w-[80%]  md:w-[65%] lg:w-[55%] xl:w-[47%] flex-col gap-10 sm:-top-0 md:relative  md:left-6 md:z-10 md:m-0   md:gap-1 md:px-10 md:pb-4 lg:gap-[0px] lg:pb-4  xl:pb-1 ">
              <h2 className="LandingPagetext text-pretty text-center   text-white md:w-auto  text-2xs xl:text-sm md:text-left  2xl:text-lg ">
                  Welcome to Vehicle Learning Innovation. Connecting Learners with Certified Training Institutes for a Seamless Licensing Journey
              </h2>
              
              <p className="Regularfont text-pretty text-center   font-thin text-white md:text-left text-4xs xl:text-2xs   2xl:text-sm lg:mt-[15px] ">
                At Vehicle Learning innovation, we bridge the gap between aspiring learner and professional training institutes.
              </p>
              <p className="Regularfont text-pretty text-center   font-thin text-white md:text-left text-4xs xl:text-2xs   2xl:text-sm ">
                Whether you're a learner eager to obtain your license or an institute aiming to expand your reach, our platform offers tailored solutions to meet your needs.
              </p>
            </div>
            <div className="flex justify-center items-center w-[70%] md:w-[35%] lg:w-[45%] xl:w-[50%]">
              <img
                className=" mt-4 w-full md:mt-0 relative lg:top-[7rem] lg:right-[5rem] 4xl:top-[7rem] 4xl:right-[3rem]"
                src={require("./Assets/LandingPageCar.png")}
                alt=""
              />
            </div>
          </div>
        </div>

        <HowVLIAddValueBtn />
        
        <SearchTiles
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
        {activeSection === "vehicle" && <VehicleType />}
        {activeSection === "license" && <LicenseTypes />}
        {activeSection === "courses" && (
          <CourseSearch
            setSearchCourse={setSearchCourse}
            searchCourse={searchCourse}
          />
        )}
        {activeSection === "courses" && searchCourse && (
          <Courses searchCourse={searchCourse} />
        )}
        {/* <LicenseTypes /> */}
        {/* <PopularCourses /> */}
        {/* <SpecialCourses /> */}
        {/* <CourseSearch /> */}
        {/* <LatestNews /> */}
        <Footer FooterBgColor="#F1FAFF" />
      </div>
    </>
  );
};

function LoginRegister() {
  const Dispatch = useDispatch();

  return (
    <nav
      id="RegisterPortion"
      className="absolute right-4 top-[105px] z-20 hidden w-auto items-center justify-center gap-[12px] lg:flex"
    >
        {/* <Link
          onClick={() => Dispatch(OpenLoginSignUp("Sign In", true))}
        >
          <TextField
              variant="outlined"
              // defaultValue="Login\Register"
              label="Student"
              InputLabelProps={{
                sx: {
                  color: "white", // Label color white
                  fontSize: "18px", // Label font size
                },
              }}
              InputProps={{
                sx: {
                  color: "white",
                  fontSize: "18px",
                  borderColor: "#EA52C6",
                  borderRadius: "21px", // Rounded border
                  cursor: "pointer", // Pointer cursor for the whole field
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#EA52C6",
                    borderWidth: "2px", // Set border thickness to 2px
                    borderRadius: "21px", // Rounded border
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#EA52C6",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#EA52C6",
                  },
                  height: "50px",
                  width: "150px",
                  "& input": {
                    paddingInline: "15px", // Correct way to apply padding to the input field
                    cursor: "pointer", // Ensure pointer cursor inside input field
                  },
                },
              }}
              size="small"
            >Login\Register</TextField>
        </Link> */}

        <TextField
          variant="outlined"
          label="Learner"
          InputLabelProps={{
            sx: {
              color: "white",
              fontSize: "18px",
            },
          }}
          InputProps={{
            sx: {
              borderRadius: "15px",
              cursor: "pointer",
              height: "50px",
              width:"180px",
              display: "flex",
              alignItems: "center",
              paddingBox:"10px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6 !important", // Ensures border color applies
                borderWidth: "2px",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
            },
            startAdornment: (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Sign In", true, "", "Student"))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Login
                </Button>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    paddingInline: "5px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Register
                </Button>
              </Box>
            ),
          }}
        />

      <TextField
          variant="outlined"
          label="Partner"
          InputLabelProps={{
            sx: {
              color: "white",
              fontSize: "18px",
            },
          }}
          InputProps={{
            sx: {
              borderRadius: "15px",
              cursor: "pointer",
              height: "50px",
              width:"170px",
              display: "flex",
              alignItems: "center",
              paddingBox:"10px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6 !important", // Ensures border color applies
                borderWidth: "2px",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
            },
            startAdornment: (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Sign In", true, "Partner", "Institute"))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    paddingInline: "5px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Login
                </Button>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Register", true, "Partner"))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    paddingInline: "5px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Register
                </Button>
              </Box>
            ),
          }}
        />

        {/* <Link
          onClick={() => Dispatch(OpenLoginSignUp("Register", true))}
        >
          <TextField
            variant="outlined"
            defaultValue="Login\Register"
            label="Partner"
            InputLabelProps={{
              sx: {
                color: "white", // Label color white
                fontSize: "18px", // Label font size
              },
            }}
            InputProps={{
              sx: {
                color: "white",
                fontSize: "18px",
                borderColor: "#EA52C6",
                borderRadius: "21px", // Rounded border
                cursor: "pointer", // Pointer cursor for the whole field
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#EA52C6",
                  borderWidth: "2px", // Set border thickness to 2px
                  borderRadius: "21px", // Rounded border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#EA52C6",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#EA52C6",
                },
                height: "50px",
                width: "150px",
                "& input": {
                  paddingInline: "15px", // Correct way to apply padding to the input field
                  cursor: "pointer", // Ensure pointer cursor inside input field
                },
              },
            }}
            size="small"
          />
        </Link> */}
        {/* <Link
          className="Regularfont  text-xs text-white no-underline xl:text-2xs"
          onClick={() => Dispatch(OpenLoginSignUp("Sign In", true))}
        >
          Login
        </Link>
        <Link
          className={`Regularfont rounded-[25px] bg-[#EA52C6] text-center text-xs text-white
                                    no-underline     lg:py-3         lg:px-7
                                    xl:py-4     xl:px-10        xl:text-2xs 
                        2xl:py-5                 2xl:px-12       `}
          onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
        >
          Register
        </Link> */}
    </nav>
  );
}
export default LandingPage;
